<template>
  <div v-parallax-fit="parallax" class="slide-sticker" id="slidesticker-2">
    <img src="/themes/rise-theme/dist/images/estate/character-view/henry/07_LegalAd@2x.png">
  </div>
</template>

<script>
export default {
  data() {
    return {
      mutationObserver: null,
      parallax: [
        {
          start: 16000,
          end: 17000,
          fromStyle: { transform: 'scale(0) rotate(0deg) translateX(0%) translateY(0%)' },
          toStyle: { transform: 'scale(1) rotate(360deg) translateX(0%) translateY(0%)' },
          easing: 'linear'
        },
        {
          start: 18000,
          end: 19000,
          fromStyle: { transform: 'scale(1) rotate(360deg) translateX(0%) translateY(0%)' },
          toStyle: { transform: 'scale(1) rotate(360deg) translateX(45%) translateY(-120%)' },
          easing: 'linear'
        },
        {
          start: 19000,
          end: 25000,
          fromStyle: { transform: 'scale(1) rotate(360deg) translateX(45%) translateY(-120%)' },
          toStyle: { transform: 'scale(1) rotate(360deg) translateX(45%) translateY(50%)' },
          easing: 'linear'
        },
        {
          start: 25000,
          end: 26000,
          fromStyle: { transform: 'scale(1) rotate(360deg) translateX(45%) translateY(50%)' },
          toStyle: { transform: 'scale(1) rotate(360deg) translateX(45%) translateY(550%)' },
          easing: 'linear'
        }
      ]
    }
  },
  mounted() {
    const self = this;
    const evidence = {
      items: [
        {
          image: '/themes/rise-theme/dist/images/estate/character-view/henry/evidence/6.png',
          url: 'https://www.reuters.com/article/us-usa-property-heirs/u-s-government-hears-woeful-testimony-from-heirs-property-owners-idUSKCN1V42DW',
          link_title: {
			'en': "U.S. government hears woeful testimony from 'heirs' property' owners",
			'es': 'Gobierno de EE. UU. escucha lamentables testimonios de propietarios de "herederos"'
		  },
        }
      ],
      text: {
		'en': '"While there are no firm estimates on the scope of heirs’ property, [it is estimated] that nearly 3.8 million acres has been lost over past decades, with a value of some $6 billion.Of the land lost over the past century, 85 percent has belonged to African Americans."',
		'es': '"Si bien no hay estimaciones firmes sobre el alcance de la propiedad de los herederos, [se estima] que se han perdido casi 3,8 millones de acres en las últimas décadas, con un valor de unos $ 6 mil millones. De la tierra perdida durante el siglo pasado, 85 por ciento ha pertenecido a los afroamericanos".'
	  }
    };
    const text = {
		'en': 'Ronald is not alone in his experience of having an investor take advantage of his heirs property status. Experts say investors, developers and other parties have disregarded heirs ownership and taken housing and land from rightful owners.',
		'es': 'Ronald no está solo en su experiencia de que un inversionista se aproveche del estado de propiedad de sus herederos. Los expertos dicen que los inversionistas, desarrolladores y otras partes han ignorado la propiedad de los herederos y tomado viviendas y terrenos de los propietarios legítimos.'
	};

    this.mutationObserver = new window.MutationObserver(mutationList => {
      mutationList.forEach(mutation => {
        if (mutation.target.style.transform == 'scale(1) rotate(360deg) translateX(0%) translateY(0%)') {
          self.$evidence.value = JSON.stringify(evidence);
          self.$readMore.value = text;
        }
      });
    });

    this.mutationObserver.observe(document.querySelector('#slidesticker-2'), {
      attributes: true,
      attributeFilter: ['style']
    });
  },
  unmounted() {
    this.mutationObserver.disconnect();
  },
}
</script>

<style lang="scss" scoped>
.slide-sticker {
  max-width: 250px;
  position: absolute;
  bottom: -2%;
  left: -6%;
  transition: all 0.1s linear;
}

@media screen and (max-width: 1680px) {
  .slide-sticker {
    bottom: -16%;
  }
}

@media screen and (max-width: 1280px) {
  .slide-sticker {
    max-width: 100px;
    bottom: -40%;
  }
}

@media screen and (max-width: 650px) {
  .slide-sticker {
    max-width: 60px;
    bottom: -22%;
    left: -12%;
  }
}
</style>
